<template>
  <div>
    <div v-if="!favoriteLinks || favoriteLinks.length === 0" class="no-links">
      {{ $t('favorite_link.text.no_link') }}
    </div>
    <div v-else>
      <draggable v-model="favoriteLinks" group="link" @start="drag=true" @end="drag=false">
        <div v-for="(favoriteLink, favoriteLinkIndex) in favoriteLinks" :key="favoriteLinkIndex" class="favorite-link-item" :link-index="favoriteLinkIndex">
          <input autocomplete="false" style="display:none" type="text" name="faketextremembered">
          <input autocomplete="false" style="display:none" type="password" name="fakepasswordremembered">
          <div class="row">
            <div class="col-sm-1 arrow-area">
              <i class="fa fa-arrows" />
            </div>
            <div class="col-sm-3">
              <input-control v-model="favoriteLink.alias" type="text" :name="'favorite-link-alias-' + favoriteLinkIndex" :required="true" :title="$t('favorite_link.label.alias')" />
            </div>
            <div class="col-sm-3">
              <input-control
                v-model="favoriteLink.menuId"
                type="select"
                :options="availableMenus"
                :name="'favorite-link-menu-' + favoriteLinkIndex"
                :title="$t('favorite_link.label.menu')"
                :disabled="favoriteLink.url?true:false"
              />
            </div>
            <div class="col-sm-4">
              <input-control v-model="favoriteLink.url" type="text" :name="'favorite-link-url-' + favoriteLinkIndex" :title="$t('favorite_link.label.url')" :disabled="favoriteLink.menuId?true:false" />
            </div>
            <div class="col-sm-1 delete-button-area">
              <button class="btn btn-danger" @click="deleteLink(favoriteLinkIndex)">
                <i class="fa fa-trash" />
              </button>
            </div>
          </div>
        </div>
      </draggable>
      <div class="row">
        <div class="col-sm-1 arrow-area" />
        <div class="col-sm-3">
          <pig-tail-label :message="$t('favorite_link.guide.alias')" />
        </div>
      </div>
    </div>
    <div class="controls">
      <button class="btn btn-primary" @click="addLink()">
        {{ $t('common.text.add') }}
      </button>
      <button class="btn btn-primary" :disabled="!isModified()" @click="save()">
        {{ $t('common.button.save') }}
      </button>
    </div>
    <b-modal
      id="update-confirm-modal"
      ref="updateConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="saveProcess"
    >
      <p class="my-4" v-html="$t('common.modal.text.update_confirm')" />
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    listUrl: {
      type: String,
      default: '/favorite_link/list/favoriteLink'
    },
    updateUrl: {
      type: String,
      default: '/favorite_link/update/favoriteLink'
    }
  },
  data() {
    return {
      availableMenus: [],
      favoriteLinks: [],
      siteId: process.env.siteId
    }
  },
  mounted() {
    this.loadFavoriteLinks()
    this.availableMenus = [
      {
        text: this.$t('common.placeholder.select'),
        value: ''
      }
    ]
    this.addAvailableMenu(this.menus, this.availableMenus)
  },
  methods: {
    addAvailableMenu(menus, availableMenus) {
      if (menus) {
        for (let i = 0; i < menus.length; i++) {
          if (menus[i].module) {
            availableMenus.push({
              value: menus[i].id,
              text: this.$t('menu.nm.' + this.siteId + '.' + menus[i].menu)
            })
          }
          if (menus[i].children) {
            this.addAvailableMenu(menus[i].children, this.availableMenus)
          }
        }
      }
    },
    isModified() {
      if (!this.originalFavoriteLinks || !this.favoriteLinks) {
        return false
      }
      return !window.isObjectEquals(
        this.originalFavoriteLinks,
        this.favoriteLinks
      )
    },
    saveProcess() {
      this.$axios.$post(this.updateUrl, this.favoriteLinks).then(response => {
        if (response.resultCode === 'success') {
          this.favoriteLinks = response.data
          this.originalFavoriteLinks = JSON.parse(
            JSON.stringify(this.favoriteLinks)
          )
          this.$toast.info(this.$t(response.message))
          this.$store.commit('SET_FAVORITE_LINKS', this.originalFavoriteLinks)
        } else {
          this.$toast.error(this.$t(response.message))
        }
      })
    },
    save() {
      for (let i = 0; i < this.favoriteLinks.length; i++) {
        const link = this.favoriteLinks[i]
        if (!link.url && !link.menuId) {
          this.$toast.error(this.$t('validation.text.no_url_and_menu'))
          $(this.$el)
            .find('[link-index=' + i + ']')
            .fadeOut(400, 'linear', () => {
              $(this.$el)
                .find('[link-index=' + i + ']')
                .fadeIn()
            })
          return
        }
      }
      this.validateUnder(this.$el, '.app-body', () => {
        this.showModal('updateConfirmModalRef')
      })
    },
    loadFavoriteLinks() {
      this.$axios.$get(this.listUrl).then(response => {
        if (response.resultCode === 'success') {
          this.favoriteLinks = response.data
          this.originalFavoriteLinks = JSON.parse(
            JSON.stringify(this.favoriteLinks)
          )
        } else {
          this.$toast.error(this.$t(response.message))
        }
      })
    },
    addLink() {
      this.favoriteLinks.push({ menuId: '' })
    },
    deleteLink(index) {
      this.favoriteLinks.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.favorite-link-item {
  padding: 10px 0;
  cursor: move;
}
.no-links {
  padding: 80px 0;
  text-align: center;
}
.delete-button-area {
  text-align: right;
  padding-top: 30px;
}
.arrow-area {
  text-align: right;
  padding: 30px 10px;
}
.controls {
  text-align: right;
}
</style>
